import RequestPageIcon from '@mui/icons-material/RequestPage';
import CustomerApplicationsList from './CustomerApplicationsList';
import {CustomerApplicationShow} from './CustomerApplicationShow';

export default {
    icon: RequestPageIcon,
    list: CustomerApplicationsList,
    show: CustomerApplicationShow
};
